import React, { useEffect, useState } from "react";
import { Dropdown, DropdownButton } from "react-bootstrap";
import { httpAdmin } from "../../Apis/commonApis";
import Modal from "react-bootstrap/Modal";
import swal from "sweetalert";
import { currentCareSiteId } from "../../redux-toolkit/reducer/switchSites";
import "../SalesFunnel/SalesFunnel.css";
import { AiOutlineClose } from "react-icons/ai";
import { ShowSwal } from "../../utils/alertSwal";
import AwsLocation from "../../utils/AwsLocation";
import { AiFillPrinter } from "react-icons/ai";
import JsonDownload from "../../components/DownloadExcel/DownloadExcel";
import { getFullName, handleDataPrint } from "../../utils/CommonFunctions";
import { useForm } from "react-hook-form";

export default function LeadsActions(props) {
  const { leadData, leadsId, applyDateFilter, rowData, leadAccess } = props;

  const {
    register,
    handleSubmit,
    unregister,
    setValue,
    watch,
    reset,
    formState: { errors },
  } = useForm();

  let initialVals = {
    longitude: 0,
    lattitude: 0,
    address: "",
    first_Name: "",
    last_Name: "",
    referral: "",
    typeOfPlan: "",
    ratePerWeek: "",
    salesPerson: "",
    salesPersonEmail: "",
    leadsStatus: "earlyStage",
    // clientType: "",
  };
  const [leadsFormData, setLeadsFormData] = useState(initialVals);
  const [actionType, setActionType] = useState("create");
  const [showModal, setShowModal] = useState(false);
  const [locationText, setLocationText] = useState(null);
  const [location, setLocation] = useState(null);

  const handleSaveLead = async (postData) => {
    let finalValues = {
      ...postData,
      careHomeId: currentCareSiteId,
      longitude: 0,
      lattitude: 0,
    };
    if (location) {
      finalValues.location = location?.Label;
      finalValues.longitude = location?.longitude;
      finalValues.lattitude = location?.latitude;
    }
    let endPoint = "createLeads";
    if (actionType === "Edit") {
      finalValues.leadId = leadsId[0];
      endPoint = "editLeads";
    } else if (actionType === "Change Status") {
      endPoint = "markLeadsStatus";
      finalValues = {
        leadId: leadsId,
        leadsStatus: postData.leadsStatus,
        careHomeId: currentCareSiteId,
      };
    }
    closeModal();
    const res = await httpAdmin(endPoint, "post", finalValues, null);
    ShowSwal(res.status, res.message);
    if (res.status) {
      applyDateFilter();
    }
  };

  const deleteLeads = async () => {
    const res = await httpAdmin(
      "deleteClient",
      "post",
      { clientId: leadsId, careHomeId: currentCareSiteId },
      null
    );
    if (res.status) {
      applyDateFilter();
    }
    ShowSwal(res.status, res.message);
  };

  const makeLeadToClient = async () => {
    const res = await httpAdmin(
      "makeClient",
      "post",
      { leadId: leadsId, careHomeId: currentCareSiteId },
      null
    );
    if (res.status) {
      applyDateFilter();
    }
  };

  function awsLocationHandler(locVal) {
    if (locVal) {
      setLocation(locVal);
    }
  }

  const openModal = (type) => {
    setActionType(type);
    if (type === "Create") {
      setValue("address", "");
      setValue("first_Name", "");
      setValue("last_Name", "");
      setValue("referral", "");
      setValue("typeOfPlan", "");
      setValue("ratePerWeek", "");
      setValue("salesPerson", "");
      setValue("salesPersonEmail", "");
      setValue("leadsStatus", "");
      setShowModal(true);
    } else if (type === "Edit") {
      if (leadsId.length === 0) {
        swal("Error!", "Please Select To Edit", "error");
      } else if (leadsId.length > 1) {
        swal("Error!", "Please Select Only One To Edit", "error");
      } else {
        const selectedLeadData = leadData.data.find(
          (item) => item._id === leadsId[0]
        );
        setLocationText(selectedLeadData?.location ?? "");
        setLocation({
          address: selectedLeadData?.location ?? "",
          latitude: selectedLeadData?.loc?.coordinates?.[0] ?? 0,
          longitude: selectedLeadData?.loc?.coordinates?.[1] ?? 0,
        });
        setValue("address", selectedLeadData?.address ?? "");
        setValue("first_Name", selectedLeadData?.first_Name ?? "");
        setValue("last_Name", selectedLeadData?.last_Name ?? "");
        setValue("referral", selectedLeadData?.referral ?? "");
        setValue("typeOfPlan", selectedLeadData?.clientPlanType ?? "");
        setValue("ratePerWeek", selectedLeadData?.invoiceRate ?? "");
        setValue("salesPerson", selectedLeadData?.salesPerson ?? "");
        setValue("salesPersonEmail", selectedLeadData?.salesPersonEmail ?? "");
        setValue("leadsStatus", selectedLeadData?.leadsStatus ?? "");
        // setValue("Self-Funded", selectedLeadData?.leadsStatus ?? "");

        setShowModal(true);
      }
    } else {
      if (leadsId.length < 1) {
        swal(
          "Error!",
          "Please Select To Atleast One To Change Status",
          "error"
        );
      } else if (type === "delete") {
        swal({
          title: "Are you sure??",
          text: "Click below to proceed",
          buttons: {
            cancel: "Cancel",
            succeed: "Yes",
          },
        }).then((result) => {
          if (result) {
            deleteLeads();
          } else {
            console.log("rejected");
          }
        });
      } else if (type === "addtoclient") {
        swal({
          title: "Are you sure??",
          text: "Click below to proceed",
          buttons: {
            cancel: "Cancel",
            succeed: "Yes",
          },
        }).then((result) => {
          if (result) {
            makeLeadToClient();
          } else {
            console.log("rejected");
          }
        });
      } else {
        setShowModal(true);
      }
    }
  };

  const closeModal = () => {
    reset();
    setLocationText(null);
    setShowModal(false);
  };

  const downloadData = rowData?.map((item) => {
    return {
      ["ProspectName"]: getFullName(item),
      //  `${item.first_Name} ${item.last_Name}`,
      ["Referral"]: item.referral,
      ["Type of Plan"]: item.typeOfPlan,
      ["Fee Rate"]: item.ratePerWeek,
      ["Contact Name"]: item.keycontact?.map((item) => item.name)?.join(", "),
      ["Tel"]: item.keycontact?.map((item) => item.phone)?.join(", "),
      ["Email"]: item.keycontact?.map((item) => item.email)?.join(", "),
      ["Sales Person"]: item.salesPerson,
      ["Client Add Date"]: item.addedTimestamp,
      ["Status"]: item.leadsStatus,
    };
  });

  return (
    <>
      <div className="row align-items-center mt-3 pt-2">
        {/* <div
          className="row col-sm-12 col-md-6 col-lg-6 m-auto overViewWages_Responsive"
          style={{ transform: "translateX(-40px)" }}
        > */}
        <div className="col-12 col-md-11 col-lg-12 col-xl-12 d-flex justify-content-center gap-3 overViewWages_Responsive">
          <div className="sechudleCard" style={{ color: "#828282" }}>
            <p>Early Stage</p>
            <h5>{leadData?.earlyStage}</h5>
          </div>
          <div className="sechudleCard" style={{ color: "#2D9CDB" }}>
            <p>Qualified</p>
            <h5>{leadData?.qualified}</h5>
          </div>
          <div className="sechudleCard" style={{ color: "#27AE60" }}>
            <p>Success</p>
            <h5>{leadData?.success}</h5>
          </div>
          <div className="sechudleCard" style={{ color: "#EB5757" }}>
            <p>Case Closed</p>
            <h5>{leadData?.caseClosed}</h5>
          </div>
          <div className="sechudleCard" style={{ color: "#F2994A" }}>
            <p>Added-as-Client</p>
            <h5>{leadData?.addToClient}</h5>
          </div>
        </div>
        {/* </div> */}

        <div className="col-md-12 d-flex justify-content-between ">
          <div>
            <AiFillPrinter
              className="me-3 ms-1 curser_point"
              onClick={() => handleDataPrint(downloadData)}
            />
            <a className="curser_point">
              <JsonDownload
                fileName="leads-excel"
                downloadfile={downloadData}
              />
            </a>
          </div>
          <div className="btns_head my-1">
            <DropdownButton id="dropdown-basic-button" title="Actions">
              <Dropdown.Item
                disabled={leadAccess !== "full"}
                onClick={() => openModal("Create")}
              >
                Create New Lead
              </Dropdown.Item>
              <Dropdown.Item
                disabled={leadAccess !== "full"}
                onClick={() => openModal("Edit")}
              >
                Edit
              </Dropdown.Item>
              <Dropdown.Item
                disabled={leadAccess !== "full"}
                onClick={() => openModal("Change Status")}
              >
                {" "}
                Change Status{" "}
              </Dropdown.Item>
              <Dropdown.Item
                disabled={leadAccess !== "full"}
                onClick={() => openModal("delete")}
              >
                {" "}
                Delete{" "}
              </Dropdown.Item>
              <Dropdown.Item
                disabled={leadAccess !== "full"}
                onClick={() => openModal("addtoclient")}
              >
                {" "}
                Add to Clients Section
              </Dropdown.Item>
            </DropdownButton>
          </div>
        </div>
      </div>

      {showModal && (
        <Modal className="viewModal" show={showModal} onHide={closeModal}>
          <Modal.Header>
            <Modal.Title>
              <span>{actionType}</span>
              <span>
                <AiOutlineClose className="curser_point" onClick={closeModal} />
              </span>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body style={{ padding: "10px 20px" }}>
            {actionType !== "Change Status" ? (
              <div className="row">
                <div className="my-1 col-md-6">
                  <label className={`form-label m-0`}>First Name</label>
                  <input
                    type="text"
                    className="form-control"
                    name="first_Name"
                    {...register("first_Name", {
                      required: true,
                      pattern: /^[A-Za-z ]+$/i,
                      min: 1,
                    })}
                  />
                  {errors?.first_Name?.type === "pattern" && (
                    <p className="error_style">Alphabet only</p>
                  )}
                  {errors?.first_Name?.type === "required" && (
                    <p className="error_style">This field is required</p>
                  )}
                  {errors?.first_Name?.type === "min" && (
                    <p className="error_style">This field is required</p>
                  )}
                </div>

                <div className="my-1 col-md-6">
                  <label className={`form-label m-0`}>Last Name</label>
                  <input
                    type="text"
                    className="form-control"
                    name="last_Name"
                    {...register("last_Name", {
                      required: true,
                    })}
                  />
                  {errors?.last_Name?.type === "required" && (
                    <p className="error_style">This field is required</p>
                  )}
                </div>

                <div className="my-1 col-md-6">
                  <label className={`form-label m-0`}>Plan Type</label>
                  <select
                    className="form-select"
                    name="typeOfPlan"
                    {...register("typeOfPlan", {
                      required: true,
                    })}
                  >
                    <option value="">--Select--</option>
                    <option value="Council">Council</option>
                    <option value="Self-Funded">Private</option>
                  </select>
                  {errors?.typeOfPlan?.type === "required" && (
                    <p className="error_style">This field is required</p>
                  )}
                </div>
                <div className="my-1 col-md-6">
                  <label className={`form-label m-0`}>Fee Rate</label>
                  <input
                    type="number"
                    className="form-control"
                    name="ratePerWeek"
                    {...register("ratePerWeek", {
                      required: "This field is required",
                      min: {
                        value: 0,
                        message: "Rate per week must be 0 or greater",
                      },
                    })}
                  />
                  {errors.ratePerWeek && (
                    <p className="error_style">{errors.ratePerWeek.message}</p>
                  )}
                </div>
                <div className="mt-1 col-md-12 mb-2">
                  <label className="form-label m-0">Location</label>
                  <AwsLocation
                    awsLocationHandler={awsLocationHandler}
                    defaultVal={locationText}
                  />
                </div>
                <div className="mb-1 col-md-6">
                  <label className={`form-label m-0`}>Sales Person Name</label>
                  <input
                    type="text"
                    className="form-control"
                    name="salesPerson"
                    {...register("salesPerson", {
                      required: true,
                    })}
                  />
                  {errors?.salesPerson?.type === "required" && (
                    <p className="error_style">This field is required</p>
                  )}
                </div>
                <div className="mb-1 col-md-6">
                  <label className={`form-label m-0`}>Sales Person Email</label>
                  <input
                    type="email"
                    className="form-control"
                    name="salesPersonEmail"
                    {...register("salesPersonEmail", {
                      required: true,
                    })}
                  />
                  {errors?.salesPersonEmail?.type === "required" && (
                    <p className="error_style">This field is required</p>
                  )}
                </div>
                <div className="my-1 col-md-6">
                  <label className={`form-label m-0`}>Referral</label>
                  <input
                    type="text"
                    className="form-control"
                    name="referral"
                    {...register("referral", {
                      required: false,
                    })}
                  />
                  {errors?.referral?.type === "required" && (
                    <p className="error_style">This field is required</p>
                  )}
                </div>
                <div className="my-1 col-md-6">
                  <label className={`form-label m-0`}>Leads Status</label>
                  <select
                    className="form-select"
                    name="leadsStatus"
                    {...register("leadsStatus", {
                      required: true,
                    })}
                  >
                    <option value="earlyStage"> Early Stage</option>
                    <option value="qualified"> Qualified</option>
                    <option value="success"> Success</option>
                    <option value="caseClosed"> Case Close</option>
                  </select>
                  {errors?.leadsStatus?.type === "required" && (
                    <p className="error_style">This field is required</p>
                  )}
                </div>
              </div>
            ) : (
              <form>
                <div className="row">
                  <div className="my-1 col-md-12">
                    <label className={`form-label m-0`}>Leads Status</label>
                    <select
                      className="form-select"
                      defaultValue="earlyStage"
                      name="leadsStatus"
                      {...register("leadsStatus", {
                        required: true,
                      })}
                    >
                      <option value=""> Select Status</option>
                      <option value="earlyStage"> Early Stage</option>
                      <option value="qualified"> Qualified</option>
                      <option value="success"> Success</option>
                      <option value="caseClosed"> Case Close</option>
                    </select>
                    {errors?.leadsStatus?.type === "required" && (
                      <p className="error_style">This field is required</p>
                    )}
                  </div>
                </div>
              </form>
            )}
          </Modal.Body>
          <Modal.Footer>
            <div className="d-flex">
              <button
                className="btn"
                type="button"
                onClick={handleSubmit(handleSaveLead)}
              >
                {actionType === "Edit" ? "Save" : actionType}
              </button>
            </div>
          </Modal.Footer>
        </Modal>
      )}
    </>
  );
}
